export default {
  Excellent: '优秀',
  Good: '良好',
  Error: '异常',
  ExcellentTip: '当前时间区间内未发生关键异常事件',
  GoodTip: '当前时间区间内发生关键异常事件且已恢复',
  ErrorTip: '当前时间区间内发生关键异常事件且未处理',
  Type: '监控类型',
  HealthStatus: '健康状态',
  Branch: '分支机构',
  Flow: '流量',
  Overview: '概览',
  BranchNums: '分支机构数',
  ServiceGateway: '服务中网关',
  ServiceErrorGateway: '服务异常网关',
  ServiceHealthStatus: '近24小时服务健康状态',
  AlarmEvent: '告警事件',
  BusinessIndicators: '近24小时业务关键指标',
  NetworkMonitor: '网络质量监控',
  UpBandwidthPeak: '上行带宽峰值',
  DownBandwidthPeak: '下行带宽峰值',
  Delay: '时延',
  Jitter: '抖动',
  PacketLoss: '丢包',
  BranchHealthStatus: '近24小时分支健康状态',
  BranchFlowTop5: '近24小时分支流量（top5）',
  BusinessDataAnalysis: '业务数据分析',
  CompareUP: '与24小时前数据对比，数据增长',
  CompareDown: '与24小时前数据对比，数据减少',
  CompareUnchange: '与24小时前数据对比，维持不变',
  ServiceHealthTips1: '服务健康状态为关键事件的常用指标监控概览，您可以作为告警配置的参考依据，前往',
  LastHealthTips: '对具体事件进行更细粒度的监控。', // ServiceHealthTips1 + 告警配置 + ServiceHealthTips2 为一句
  BranchHealthTips1: '分支健康状态为分支服务的常用指标监控概览，您可以作为告警配置的参考依据，前往',
  BandwidthRateCompareUP: '与24小时前数据对比，最大带宽使用率（即上下行最大使用带宽和采购带宽的比率）增长',
  BandwidthRateCompareDown: '与24小时前数据对比，最大带宽使用率（即上下行最大使用带宽和采购带宽的比率）减少',
  BandwidthRateCompareUnchange: '与24小时前数据对比，最大带宽使用率（即上下行最大使用带宽和采购带宽的比率）维持不变',
  BandwidthUsage: '最大带宽使用率',
  PeakBandwidthUtilizationRateOfUplinkDownlinkLast12h: '近12h上/下行峰值带宽使用率',
}